<template>
  <div class="notify_boxs" style="overflow: scroll;height: 290px" @scroll="handleScroll">
    <div class="item_box">
      <div v-for="item in resultTargetDataList" :key="item.id" :class="[item.isRead!==0?'item_check item':'item']">
        <div class="items sp_items" @click.stop="handleClick(item)"
             :style="item.messageType===1? item.isClick === 0?'cursor: pointer':'':''">
          <div class="left_box">
            <div class="left">
              <el-avatar
                  :size="36"
                  :src="item.icon"
              />
            </div>
            <div class="right">
              <div style="display: flex;justify-content: space-between;align-items: center;width: 100%">
                <div class="tops">{{ item.titles }}</div>
                <div class="right_box">
                  {{ item.createTime }}
                </div>
              </div>
              <div style="width: 100%">
                <div style="display: flex;justify-content: space-between;align-items: center;width: 100%">
                  <div class="content">{{ item.innerContent }}</div>
                  <el-button v-if="item.messageType===1" type="primary" size="small" link
                             style="padding:0px;font-size: 14px" @click.stop="handleToShow(item)">
                    {{ $t('common.chuli.message') }}>>>
                  </el-button>
                  <el-button
                      v-if="item.messageType===11||item.messageType===10||item.messageType===12||item.messageType===7||item.messageType===13||item.messageType===14"
                      type="primary" size="small" link
                      style="padding:0px;font-size: 14px" @click.stop="handleToShow(item)">
                    {{ $t('common.message.goto.show') }}>>>
                  </el-button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <!--      <div style="height: 35px;width: 100%"></div>-->
      <slot name="loadings"></slot>
    </div>
  </div>
  <!--  加入团队-->
  <JoinTeam v-if="dialogVisible" v-model="dialogVisible"
            @close="close" :targetItem="activeItem" :flag="1" @getUnReadList="getUnRead"></JoinTeam>
</template>

<script setup>
import JoinTeam from "@/components/DiaPops/Message/JoinTeam/index.vue";
import {computed, defineEmits, ref} from "vue";
import {useRouter} from "vue-router";
import {useStore} from "vuex";
import {ElMessage} from "element-plus";
import {throttle} from "@/utils/mylodash";
import {TIME_OUT} from "@/utils/statusParams";
import {i18n} from "@/lang";

const router = useRouter()
const emit = defineEmits(['closeDropdownRef', 'changePages', 'getUnReads'])
const store = useStore()

const {resultTargetDataList} = defineProps({
  resultTargetDataList: {
    type: Array,
    default: []
  }
})

const isSelect = ref(false)

const dialogVisible = ref(false)
const close = () => {
  dialogVisible.value = false
}


const activeItem = ref(null)
const handleClick = (item) => {
  // if (item.messageType === 1 && item.isClick === 0) {
  activeItem.value = item;

  if (!(item.messageType === 1 && item.isClick === 0)) {
    emit('closeDropdownRef')
  }
  // router.push('/notificationList/systemNotification')
  openNewTab('/notificationList/systemNotification')
}

const handleScroll = throttle((event) => {
  const target = event.target;
  console.log('fff')
  // if (target.scrollHeight - target.scrollTop === target.clientHeight) {
  // Reached the bottom
  emit('changePages')
  // }
}, 300)


function getUnRead() {
  emit('getUnReads')
}

const teamList = computed(() => store.state.email.teamList)
const handleToShow = async (item) => {
  const {messageType, id, jsonData} = item
  const {
    teamName,
    userName,
    customerName,
    subject,
    customerId,
    expirationTime,
    productSort,
    memberTypes
  } = (jsonData && JSON.parse(jsonData)) || {};

  const targetTeamId = teamList.value.filter(item => item.name === teamName)
  const targetTearNameIndex = teamList.value.findIndex(item => item.name === teamName)

  // 系统工位/存储空间/营销邮件/智能点数
  const productSortArray = [i18n.global.t('userinfo.vip.work'), i18n.global.t('userinfo.vip.space'), i18n.global.t('userinfo.vip.edm'), i18n.global.t('userinfo.vip.AI')]
  const findTargetProduct = productSortArray[productSort]

  const memberTypesArray = [i18n.global.t('vip.type.1'), i18n.global.t('vip.type.2'), i18n.global.t('vip.type.3')]
  const findTargetMember = memberTypesArray[memberTypes - 5]

  // 更新阅读状态
  activeItem.value = item
  updateRead()
  if (messageType === 1) {
    //   团队邀请对话框
    dialogVisible.value = true
  } else if (messageType === 13) {
    //   跳转到 指定客户的客户详情
    // console.log(`/email/customer/detail/${customerId}?type=1`, 'asfasfa')
    openNewTab(`/email/customer/detail/${customerId}`, {type: 1})
  } else {
    if (targetTeamId.length > 0 && targetTearNameIndex !== -1) {
      await store.commit("email/setCurTeamID", targetTeamId[0].id)
      await store.dispatch('email/getTeamList', {isUpdate: true})
      await localStorage.setItem('tabIndex', targetTearNameIndex);
      await store.dispatch("user/checkUserInfoIsAdmin", {teamId: targetTeamId[0].id})
      await new Promise(resolve => setTimeout(resolve, 50));
      if (messageType === 11 || messageType === 10) {
        openNewTab('/email/examine');
      } else if (messageType === 12 || messageType === 14) {
        openNewTab('/email/draft');
      } else if (messageType === 7) {
        // 切换 团队
        openNewTab('/email/customer/setting', {activeName: '4'});
      } else if (messageType === 15) {
        // 完善账户信息
        openNewTab('/personal/basic')
      } else if (messageType === 16 || messageType === 17) {
        if (productSort === 1) {
          openNewTab('/personal/station')
        } else if (productSort === 2) {
          openNewTab('/personal/storeDetails')
        } else if (productSort === 3) {
          openNewTab('/personal/edmDetails')
        } else if (productSort === 4) {
          openNewTab('/personal/aiDetails')
        }
      } else if (messageType === 18) {
        openNewTab('/personal/basic')
      }
    } else {
      if (messageType === 19) {
        // 客户回复
        openNewTab('/personal/repairOrder')
      } else {
        ElMessage.warning(`${teamName} ${i18n.global.t('team.empty.have')}`)
      }
    }
  }
}

const openNewTab = (path, query = {}) => {
  const routeInfo = router.resolve({path, query});
  window.open(routeInfo.href, '_blank');
};


const updateRead = async () => {
  // 点击以后前端 需要更新
  const result = resultTargetDataList.map(item => {
    if (item.id === activeItem.value.id) {
      return {...item, isRead: 1}
    } else {
      return item
    }
  })
  const findTargetItem = resultTargetDataList.find(item => item.id === activeItem.value.id)
  // 接口更新
  await store.dispatch("message/updateMessageInfoApi", {...findTargetItem, isRead: 1})
  // 更新数据 scroll 问题
  await store.dispatch("message/getUnReadMessageListApis", {pageNo: 1, pageSize: 10, isUpdate: true})
  await store.dispatch("message/getMessageListApisDefault", {pageNo: 1, pageSize: 30})

  const index = resultTargetDataList.findIndex(item => item.id === activeItem.value.id)
  if (index !== -1) {
    resultTargetDataList.splice(index, 1)
  }

  console.log(findTargetItem, activeItem.value, 'findTargetItem')
}

</script>

<style lang="less" scoped>
.notify_boxs {
  width: 100%;
  height: auto;
  cursor: pointer;
}

.item_box {
  background: white;
  width: 100%;
  height: 100%;

  .sp_items {
    width: 100%;
  }

  .items {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .item_check {
    opacity: 0.70;
  }

  .item {
    width: 100%;
    padding: 8px 20px;
    height: auto;
    border-bottom: 1px solid #e8e8e8;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: all .3s;

    .left_box {
      width: 100%;
      display: flex;
      justify-content: flex-start;
    }

    .left {
      display: flex;
      align-items: center;
    }

    .right_box {
      color: rgb(153, 153, 153);
      height: 14px;
      font-size: 14px;
      font-weight: 400;
      line-height: 14px;
    }

    .right {
      height: 100%;
      width: 100%;
      display: flex;
      margin-left: 4px;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;

      .tops {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #444444;
      }

      .content {
        width: 190px;
        height: auto;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #999999;
      }
    }
  }

  .item:hover {
    cursor: pointer;
    background: #EEF7FF;
  }
}

</style>